export const numberInput = {
  inputBelowMinValue: 'Bitte geben sie eine Zahl ein, welche grösser als {min} ist.',
}
